export default "__VITE_ASSET__ChDudYRG__"